<template>
  <b-card class="mini-stats-wid">
    <b-card-body>
      <div class="media">
        <div class="me-3 align-self-center">
          <i class="mdi h2 mb-0 text-primary" :class="icon"></i>
        </div>
        <div class="media-body">
          <p class="text-muted mb-2">
            {{ title }}
            <hint v-show="hint">
              <span>{{ hint }}</span>
            </hint>
          </p>
          <h5 class="mb-0">
              <span v-if="text">
              {{ text }}
              </span>
            <span v-else>
                -
              </span>
          </h5>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  props: ['title', 'icon', 'hint', 'text'],
  name: "KeywordTopStatCard"
}
</script>

<style scoped>

</style>